import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconThumbsDown16Filled(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconThumbsDown16Filled"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M12.368 10.022a1.5 1.5 0 0 0 1.508-1.5V4.498a1.5 1.5 0 0 0-1.5-1.5h-1.5v7.016zm-2.492.656v-7.68H4.935c-.635 0-1.201.4-1.414.998L2.088 8.028A1.5 1.5 0 0 0 3.5 10.03h2.375v2.982c0 .96 1.223 1.368 1.8.6z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconThumbsDown16Filled);
